import Skeleton from 'react-loading-skeleton'
import React from 'react'
import Btn from './Btn'

interface Props {
  title?: string
  id?: string
  statusText?: string
  isActive?: boolean
  loading: boolean
}

export const QuestCard = ({
  title,
  statusText,
  id,
  isActive,
  loading
}: Props) => {
  if (loading) {
    return (
      <Skeleton
        borderRadius={'2.4rem'}
        height={'10rem'}
        width={'100%'}
      ></Skeleton>
    )
  }

  return (
    <article className="quest-card">
      <div className={'quest-card__info'}>
        <h2 className={'quest-card__title text-h3'}>{title}</h2>
        <p
          className={'quest-card__status text-secondary-color text-body-small'}
        >
          {statusText}
        </p>
      </div>
      <div className={'quest-card__controls'}>
        <Btn to={`/quests/${id}`}>{isActive ? 'Пройти' : 'Просмотр'}</Btn>
      </div>
    </article>
  )
}
